export default {
    "work-data": "معلومات العمل",
    "day-off-request": "طلبات الإجازة",
    "materials": "المواد",
    "rates": "المعدلات",
    "employee-is-edited": "تم تعديل بيانات الموظف",
    "rate-is-added": "تم إضافة المعدل",
    'add-visit': 'إضافة زيارة',
}